import React from 'react';
import { EmojiEvents, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton, Chip } from '@mui/material';
import { ParticipantData } from '../../../../interface/Participant.interface';

interface ParticipantHandsSectionProps {
    participant: ParticipantData;
}

export const ParticipantHandsSection: React.FC<ParticipantHandsSectionProps> = ({ participant }) => {
    const handleScrollLeft = () => {
        const handsGrid = document.querySelector(`#hands-grid-${participant.uuid}`);
        if (handsGrid) {
            handsGrid.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };

    const handleScrollRight = () => {
        const handsGrid = document.querySelector(`#hands-grid-${participant.uuid}`);
        if (handsGrid) {
            handsGrid.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    return (
        <div className="hands-section">
            <h4 className="hands-section-title">
                <EmojiEvents fontSize="small" />
                Positions de ramassage
            </h4>
            <div className="hands-container">
                <IconButton
                    className="scroll-button left"
                    onClick={handleScrollLeft}
                >
                    <ChevronLeft />
                </IconButton>
                <div className="hands-grid" id={`hands-grid-${participant.uuid}`}>
                    {(participant.shareConfigurations || []).map((config, idx) => (
                        <div
                            key={idx}
                            className={`hand-card ${config.withdrawalRank === participant.nextWithdrawalPosition ? 'is-next' : ''}`}
                        >
                            <div className="hand-position">#{config.withdrawalRank}</div>
                            <div className="hand-label">Position</div>
                            <div className="hand-shares">{config.share} parts</div>
                            {config.withdrawalRank === participant.nextWithdrawalPosition && (
                                <Chip
                                    label="Prochain"
                                    size="small"
                                    className="next-withdrawal-chip"
                                />
                            )}
                        </div>
                    ))}
                </div>
                <IconButton
                    className="scroll-button right"
                    onClick={handleScrollRight}
                >
                    <ChevronRight />
                </IconButton>
            </div>
        </div>
    );
};
